<div class="custom-toolbar">
  <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
  <div class="custom-button-container">
    @if (canCreateProduit()) {
      <yo-button
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        label="CRÉER"
        tooltip="Créer un plat ou une denrée"
        (onClick)="produitMenu.toggle($event)"
        [disabled]="!canCreate()">
      </yo-button>
    }
    <yo-button
      iconClass="fas fa-glasses"
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Contrôle des ratios au niveau des articles et des produits déclinés"
      (onClick)="checkRatios()"
      [disabled]="!produitsForGrille.length">
    </yo-button>
    <yo-button
      iconClass="fa-edit fas"
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Traitements de masse"
      (onClick)="openDialogBatch()"
      [disabled]="!produitsForGrille.length">
      <p-menu appendTo="body" #produitMenu [popup]="true" [model]="itemsProduitMenu"></p-menu>
    </yo-button>
  </div>
  <dx-text-box class="custom-toolbar-element"
               valueChangeEvent="keyup"
               (onValueChanged)="announceGlobalFilterSearch($event)"
               placeholder="Filtrer par recherche globale...">
  </dx-text-box>
  <dx-tag-box class="custom-toolbar-element"
              [multiline]="false"
              (onValueChanged)="onChangeSitesFilter($event)"
              placeholder="Filtrer par site..."
              displayExpr="libelle"
              valueExpr="id"
              [searchEnabled]="true"
              [dataSource]="sitesUtilisateurConnecteItems">
  </dx-tag-box>
  <dx-tag-box class="custom-toolbar-element"
              [multiline]="false"
              (onValueChanged)="onChangeTypesProduitFilter($event)"
              placeholder="Filtrer par type de produit..."
              displayExpr="libelle"
              valueExpr="id"
              [searchEnabled]="true"
              [dataSource]="allTypesProduitsItems">
  </dx-tag-box>
  <dx-tag-box class="custom-toolbar-element"
              [multiline]="false"
              (onValueChanged)="onChangeDeclinaisonsFilter($event)"
              placeholder="Filtrer par déclinaison..."
              displayExpr="libelle"
              valueExpr="id"
              [searchEnabled]="true"
              [dataSource]="allDeclinaisonsItems">
  </dx-tag-box>
  <dx-tag-box class="custom-toolbar-element"
              [multiline]="false"
              (onValueChanged)="onChangeFamillesProduitFilter($event)"
              placeholder="Filtrer par famille de produit..."
              displayExpr="libelle"
              valueExpr="id"
              [value]="idsFamillesProduitsSelected"
              [maxDisplayedTags]="3"
              [showSelectionControls]="true"
              [searchEnabled]="true"
              [itemTemplate]="'customTemplate'"
              [dataSource]="allFamillesProduitsItems">
    <div *dxTemplate="let item of 'customTemplate'">
      <span [ngStyle]="{'font-weight': item.parent == null ? 'bold' : 'normal'}">{{ item.libelle }}</span>
    </div>
  </dx-tag-box>
  <dx-tag-box class="custom-toolbar-element"
              [multiline]="false"
              (onValueChanged)="onChangeRegimesFilter($event)"
              placeholder="Filtrer par régime..."
              displayExpr="libelle"
              valueExpr="id"
              [searchEnabled]="true"
              [dataSource]="allRegimesItems">
  </dx-tag-box>
  <dx-button
    icon="columnchooser"
    (onClick)="openColumnChooser(grid)"
  ></dx-button>
</div>

<dx-data-grid
  [dataSource]="dataSource"
  [remoteOperations]="true"
  keyExpr="id"
  [height]="utils.getWindowAvailableHeight(122)"
  width="100%"
  [allowColumnResizing]="true"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  [columnChooser]="{ enabled: true, mode: 'select' }"
  #grid>
  <dxo-filter-row [visible]="true"></dxo-filter-row>

  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
  <dxi-column dataField="id" caption="Actions" cellTemplate="cellActionsTemplate" width="140" [allowSorting]="false"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="code" caption="Code" width="auto"></dxi-column>
  <dxi-column dataField="reference" caption="Reference" width="auto" [visible]="false"></dxi-column>
  <dxi-column dataField="hasPhoto" caption="Photo" cellTemplate="cellPhotoTemplate" width="140" [allowSorting]="false"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="site.libelle" caption="Site" cellTemplate="cellSiteTemplate"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="typeProduit.libelle" caption="Types de produit" cellTemplate="cellTypesProduitTemplate"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="libelle" caption="Produit" cellTemplate="cellProduitTemplate" width="auto"></dxi-column>
  <dxi-column dataField="produitDeclinaisons.declinaison.libelle" caption="Déclinaison"
              cellTemplate="cellDeclinaisonsTemplate" [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="familleProduit.libelle" caption="Famille de produit" cellTemplate="cellFamilleProduitTemplate"
              [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="produitContrainteAlimList" caption="Régimes" cellTemplate="cellRegimeTemplate"
              [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <dxi-column dataField="actif" caption="Actif" width="auto"></dxi-column>

  <div *dxTemplate="let cell of 'cellActionsTemplate'" class="custom-button-container">
    <yo-button size="small"
                    [theme]="ButtonThemeEnum.DEFAULT_INNER" (onClick)="openFicheIdentite(cell.row.data)"
                    [iconClass]="canModify(cell.row.data) ? 'fa fa-edit' : 'fa fa-eye'"
                    [tooltip]="'Voir le produit ' + cell.row.data.libelle">
    </yo-button>
    <ng-container *ngIf="canModify(cell.row.data)">
      <yo-button size="small"
                    [theme]="ButtonThemeEnum.DELETE_INNER" (onClick)="confirmDelete(cell.row.data)" iconClass="fa fa-trash"
                      [tooltip]="'Supprimer le produit ' + cell.row.data.libelle">
      </yo-button>
    </ng-container>
    <ng-container>
      <yo-button size="small"
                    [theme]="ButtonThemeEnum.SECONDARY_INNER" (onClick)="openPanelDuplication($event, cell.row.data)" iconClass="fa fa-copy"
                      [tooltip]="'Dupliquer le produit ' + cell.row.data.libelle">
      </yo-button>
    </ng-container>
  </div>

  <ng-container *dxTemplate="let cell of 'cellPhotoTemplate'">
    <ng-container [ngSwitch]="cell.row.data.hasPhoto">
      <ng-container *ngSwitchCase="true">
        <yo-img-entity [entityId]="cell.row.data.id" [refresh]="1" [entityName]="produitsSvc.getEntityName()"
                       [height]="50"
                       [openable]="true" format="thumb" [displayNoImage]="false" [title]="cell.row.data.libelle"
                       [ordre]="1">
        </yo-img-entity>
      </ng-container>
      <ng-container *ngSwitchCase="false">
        <yo-img-entity [entityId]="cell.row.data.id" [refresh]="1" [height]="50" format="thumb" [displayNoImage]="true"
                       [title]="cell.row.data.libelle" [ordre]="1">
        </yo-img-entity>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellSiteTemplate'">
    <yo-site [siteId]="cell.row.data.site.id" [siteLibelle]="cell.row.data.site.libelle"
             [yoDelayMsTooltip]="1500"></yo-site>
  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellTypesProduitTemplate'">
    <yo-icon-produitfab [fabrique]="cell.row.data.typeProduit.fabrique" [yoDelayMsTooltip]="1500"></yo-icon-produitfab>
    {{ cell.row.data.typeProduit.libelle | uppercase }}
  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellProduitTemplate'">
    <span class="hover-background-grey no-overflow" style="width:200px;"
          (click)="openFicheIdentite(cell.row.data)" [title]="'Voir le produit '+ cell.row.data.libelle">
      {{ cell.row.data.libelle }}
    </span>
    @if(hasDeclinaisonSansApportNutri(cell.row.data)) {
    <span class="fa fa-exclamation-triangle text-warning mg-l-5"
          title="Ce plat contient une/des denrée(s) sans apport nutritionnel">
    </span>
    }
    <div>
      <yo-gef-audit-button
        [gefAuditList]="this.gefSvc.retrieveGefAuditListByIdEntity(gefAuditList, cell.row.data.id)">
      </yo-gef-audit-button>
    </div>
  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellFamilleProduitTemplate'">
    <label class="badge badge-secondary zoom cursor">
      {{
        cell.row.data.familleProduit.parent ?
          cell.row.data.familleProduit.parent.libelle + ' / ' + cell.row.data.familleProduit.libelle :
          cell.row.data.familleProduit.libelle
      }}
    </label>
  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellDeclinaisonsTemplate'">
    <table>
      <tr>
        <td style="vertical-align: top;padding:4px; width:40px !important;">
          <yo-button size="small"
                    [theme]="ButtonThemeEnum.ADD_INNER"
                          [tooltip]="tooltipCreationDeclinaison()" [disabled]="!canCreate()"
                          iconClass="fa fa-plus"
                          (onClick)="openProduitDeclinaison(cell.row.data,undefined)">
          </yo-button>
        </td>
        <td style="vertical-align: top;padding:4px;">
          <ng-container
            *ngFor="let pd of sortProduitsDeclines(cell.row.data.produitDeclinaisons);trackBy : utils.trackByFn">
            <div>
              <span *ngIf="!pd.fabrique; else plat">
                <label class="badge badge-secondary zoom cursor" title="Fiche de la déclinaison {{pd.libelle}}"

                       (click)="openProduitDeclinaison(cell.row.data,pd)">
                  {{ (pd.libelle) | uppercase }}
                </label>
              </span>
              <ng-template #plat>
                <label class="badge badge-secondary zoom cursor"
                       title="Fiche de la déclinaison {{pd.declinaison.libelle}}"

                       (click)="openProduitDeclinaison(cell.row.data,pd)">
                  {{ pd.declinaison.libelle | uppercase }}
                </label>
              </ng-template>
            </div>
          </ng-container>
        </td>
      </tr>
    </table>

  </ng-container>

  <ng-container *dxTemplate="let cell of 'cellRegimeTemplate'">
    <div style="vertical-align: top;padding:4px;"
         *ngFor="let contrainte of produitContrainteAlimSvc.convertToContraintes(cell.row.data.produitContrainteAlimList)">
      <label class="badge badge-secondary zoom cursor">
        {{ contrainte.libelle }}
      </label>
    </div>
  </ng-container>

  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="false"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} produit(s)">
  </dxo-pager>

</dx-data-grid>

<!--PANEL DUPLICATION-->
<p-overlayPanel #opDuplication>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group ">
        <label
          [class.requiredControl]="true"
          class="genlabel  font-16"
          title=""
        >Site sur lequel dupliquer le produit</label>
        <div class="col-sm-10">
          <p-dropdown [options]="auth2Svc.utilisateur.siteListLocaux"
                      optionLabel="libelle"
                      filter="true"
                      [(ngModel)]="duplicationSiteSelected"
                      placeholder="sélection..."
                      [autoDisplayFirst]="false"
                      [style]="{'width':'360px'}">
            <ng-template let-site pTemplate="selectedItem">
          <span style="vertical-align:middle; margin-left: .5em">
            <yo-site [siteId]="site.id" [siteLibelle]="site.libelle"></yo-site></span>
            </ng-template>
            <ng-template let-site pTemplate="item">
              <div style="position: relative;height: 25px;">
                <div style="font-size:14px;margin-top:4px">
                  <yo-site [siteId]="site.id" [siteLibelle]="site.libelle"></yo-site>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 text-right">
      <yo-button
        label="Dupliquer"
        iconClass="fas fa-copy"
        [theme]="ButtonThemeEnum.DEFAULT"
        (onClick)="duplicateProduit()"
        [disabled]="duplicationSiteSelected === undefined || !produitToDuplicate">
      </yo-button>
    </div>
  </div>
</p-overlayPanel>

<yo-dialog-batch-produits></yo-dialog-batch-produits>
<yo-dialog-check-ratios></yo-dialog-check-ratios>
<yo-dialog-gef-audit></yo-dialog-gef-audit>
